module.exports = __webpack_public_path__ + "static/media/logo.fd33dfe0.svg";